import { DateOrTimeView } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { DatePickerWrapper } from '@styles/InputStyles';

interface IDateTimePickerProps {
  label?: string;
  value?: string | null;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  views?: DateOrTimeView[];
  disablePast?: boolean;
  disableFuture?: boolean;
  onChange?: (value: string | null) => void;
}

export const SelectDateTime = ({
  value,
  minDate,
  maxDate,
  views,
  disablePast = false,
  disableFuture = false,
  onChange
}: IDateTimePickerProps) => {
  const [isDatePickerFocused, setIsDatePickerFocused] = useState(false);
  const handleChange = (dateTime: Dayjs | null) => {
    const formattedValue = dateTime ? dateTime.format('YYYY-MM-DDTHH:mm:ss') : null;
    if (onChange) {
      onChange(formattedValue);
    }
  };

  return (
    <DatePickerWrapper
      isFocused={isDatePickerFocused}
      onFocus={() => setIsDatePickerFocused(true)}
      onBlur={() => setIsDatePickerFocused(false)}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DateTimePicker']}>
          <DateTimePicker
            value={value ? dayjs(value) : null}
            minDate={minDate ? dayjs(minDate) : undefined}
            maxDate={maxDate ? dayjs(maxDate) : undefined}
            disablePast={disablePast}
            views={views}
            disableFuture={disableFuture}
            onChange={handleChange}
          />
        </DemoContainer>
      </LocalizationProvider>
    </DatePickerWrapper>
  );
};
